import { useEffect, useState, useSyncExternalStore } from "react";
import axios from "axios";
import { getFxRates, setFxRates, subscribeFxRates } from "@/lib/currency";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const REFRESH_MS = 6 * 60 * 60 * 1000; // 6 hours — matches server-side TTL

/**
 * Mounts once at the app root. Fetches live FX rates from `/api/fx/rates`
 * and keeps the in-memory cache warm so every `convertFromUSD(x)` call
 * across the app uses the latest published rates.
 */
export function FxRatesProvider() {
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/fx/rates`);
        if (!cancelled) setFxRates(data);
      } catch {
        // Provider unreachable — keep whatever we have (baked-in or last cached).
      }
    };
    load();
    const id = setInterval(load, REFRESH_MS);
    return () => { cancelled = true; clearInterval(id); };
  }, []);
  return null;
}

/** React hook — components re-render when live rates arrive/refresh. */
export function useFxRates() {
  return useSyncExternalStore(
    (cb) => subscribeFxRates(cb),
    () => getFxRates(),
    () => getFxRates()
  );
}
